import Vue from 'vue'
import Router from 'vue-router'
import titles from '@/js/title'
import qs from 'qs'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/bindcard',
            name: 'bindcard',
            component: () =>
                import(/* webpackChunkName: "bindcard" */ './views/BindCard.vue'),
            meta: { keepAlive: true }
        },
        {
            path: '/banks',
            name: 'banks',
            component: () =>
                import(/* webpackChunkName: "bindcard" */ './views/Banks.vue'),
        },
        {
            path: '/prephone',
            name: 'prephone',
            component: () =>
                import(/* webpackChunkName: "bindcard" */ './views/Prephone.vue'),
        },
        {
            path: '/repay',
            name: 'repay',
            component: () =>
                import(/* webpackChunkName: "repay" */ './views/Repay.vue'),
            meta: { keepAlive: true }
        },
        {
            path: '/repayRedPacket',
            name: 'repayRedPacket',
            component: () =>
                import(/* webpackChunkName: "repay" */ './views/RepayRedPacket.vue'),
        },
        {
            path: '/helpToRepay',
            name: 'helpToRepay',
            component: () =>
                import(/* webpackChunkName: "helpToRepay" */ './views/HelpToRepay.vue'),
        },
        {
            path: '/status',
            name: 'status',
            component: () =>
                import(/* webpackChunkName: "status" */ './views/Status.vue'),
        },
        {
            path: '/offlineRepay',
            name: 'offlineRepay',
            component: () =>
                import(/* webpackChunkName: "offlineRepay" */ './views/OfflineRepay.vue'),
        },
        {
            path: '/result',
            name: 'result',
            component: () =>
                import(/* webpackChunkName: "status" */ './views/Result.vue'),
        },
        {
            path: '/middlePage',
            name: 'middlePage',
            component: () =>
                import(/* webpackChunkName: "helpToRepay" */ './views/MiddlePage.vue'),
        },
        {
            path: '/recordList',
            name: 'recordList',
            component: () =>
                import(
          /* webpackChunkName: "recordList"" */ './views/RepayRecordList.vue'
                ),
        },
        {
            path: '/loanBindCard',
            name: 'loanBindCard',
            component: () =>
                import(/* webpackChunkName: "bindcard"" */ './views/LoanBindCard.vue'),
            meta: { keepAlive: true }
        },
        {
            path: '/pay',
            name: 'pay',
            component: () => import(/* webpackChunkName: "pay"" */ './views/Pay.vue'),
        },
        {
            path: '/payResult',
            name: 'payResult',
            component: () =>
                import(/* webpackChunkName: "pay"" */ './views/PayResult.vue'),
        },
        {
            path: '/BindCardMiddlePage',
            name: 'BindCardMiddlePage',
            component: () =>
                import(/* webpackChunkName: "bindcard"" */ './views/BindCardMiddlePage.vue'),
        },
        {
            path: '/BindCardResultPage',
            name: 'BindCardResultPage',
            component: () =>
                import(/* webpackChunkName: "bindcard"" */ './views/BindCardResultPage.vue'),
        },
        // {
        //     path: '/creditCard',
        //     name: 'creditCard',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCard.vue'),
        // },
        // {
        //     path: '/creditCardRepayRecords',
        //     name: 'creditCardRepayRecords',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCardRepayRecords.vue'),
        // },
        // {
        //     path: '/creditCardRepayResult',
        //     name: 'creditCardRepayResult',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCardRepayResult.vue'),
        // },
        // {
        //     path: '/creditCardAdd',
        //     name: 'creditCardAdd',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCardAdd.vue'),
        //     meta: { keepAlive: true }
        // },
        // {
        //     path: '/creditCardRepay',
        //     name: 'creditCardRepay',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCardRepay.vue'),
        // },
        // {
        //     path: '/creditCardManage',
        //     name: 'creditCardManage',
        //     component: () =>
        //         import(/* webpackChunkName: "creditCard" */ './views/CreditCardManage.vue'),
        // },
        {
            path: '/repayInTime',
            name: 'repayInTime',
            component: () =>
                import(/* webpackChunkName: "repayInTime" */ './views/repayInTime.vue'),
        },
        {
            path: '/protocol',
            name: 'protocol',
            component: () =>
                import(/* webpackChunkName: "protocol" */ './components/Protocol/index.vue'),
        },
        {
            path: '/offlineRepayMore',
            name: 'offlineRepayMore',
            component: () =>
                import(/* webpackChunkName: "offlineRepay" */ './views/OfflineRepayMore.vue'),
        },
        {
            path: '/patchSigning',
            name: 'patchSigning',
            component: () =>
                import(/* webpackChunkName: "patchSigning" */ './views/PatchSigning.vue'),
        },
        {
            path: '/loanBindCardNew',
            name: 'loanBindCardNew',
            component: () =>
                import(/* webpackChunkName: "loanBindCardNew"" */ './views/LoanBindCardNew.vue'),
            meta: { keepAlive: true }
        },
        {
            path: '/offlineRepayGuide',
            name: 'offlineRepayGuide',
            component: () =>
                import(/* webpackChunkName: "offlineRepay" */ './views/OfflineRepayGuide.vue'),
        },
        {
            path: '/withdrawCard/bind',
            name: 'withdrawCard/bind',
            component: () =>
                import(/* webpackChunkName: "withdrawCard" */ './views/withdrawCard/BindMoreCard.vue'),
            meta: { keepAlive: true }
        },
        {
            path: '/withdrawCard/bindResult',
            name: 'withdrawCard/bindResult',
            component: () =>
                import(/* webpackChunkName: "withdrawCard" */ './views/withdrawCard/BindCardResult.vue'),
        },
    ],
    parseQuery(query) {
        return qs.parse(query)
    },
    stringifyQuery(query) {
        var result = qs.stringify(query)

        return result ? '?' + result : ''
    },
})

router.beforeEach((to, from, next) => {
    document.title = titles[to.name] || '收银台'

    Sensors.registerPage({
        product: 'other',
        product_h5: 'syt_h5',
        platform: 'H5',
        h5_channel: '',
        user_agent: navigator.userAgent,
        source: '',
        appid: window.lineAppId || '',
        line: window.lineCode || ''
    })
    Sensors.quick('autoTrackSinglePage')
    next()
})

export default router
